import { render, staticRenderFns } from "./InvalidFileAlert.vue?vue&type=template&id=58e441d5&"
import script from "./InvalidFileAlert.vue?vue&type=script&lang=js&"
export * from "./InvalidFileAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports